import { useState, Suspense, lazy, type ReactNode } from 'react'

const ChatterBotActivity = lazy(() => import('./ChatterBotActivity'))

interface RightPanelTabsProps {
  conversationId: string
  children: ReactNode // The existing dashboard/panel content (Tab 1)
}

type TabId = 'dashboard' | 'chatterbot'

export default function RightPanelTabs({ conversationId, children }: RightPanelTabsProps) {
  const [activeTab, setActiveTab] = useState<TabId>('dashboard')

  return (
    <div
      className="flex flex-col"
      style={{
        width: 280,
        flexShrink: 0,
        borderLeft: '1px solid var(--border)',
        background: 'var(--bg-surface)',
        height: '100%',
      }}
    >
      {/* Tab bar */}
      <div
        className="flex shrink-0"
        style={{ borderBottom: '1px solid var(--border)' }}
      >
        <TabButton
          active={activeTab === 'dashboard'}
          onClick={() => setActiveTab('dashboard')}
          label="Dashboard"
        />
        <TabButton
          active={activeTab === 'chatterbot'}
          onClick={() => setActiveTab('chatterbot')}
          label="ChatterBot"
          indicator
        />
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-hidden" style={{ minHeight: 0 }}>
        {activeTab === 'dashboard' ? (
          children
        ) : (
          <Suspense fallback={
            <div className="flex items-center justify-center h-full text-xs" style={{ color: 'var(--text-muted)' }}>
              Loading...
            </div>
          }>
            <ChatterBotActivity conversationId={conversationId} />
          </Suspense>
        )}
      </div>
    </div>
  )
}

function TabButton({ active, onClick, label, indicator }: {
  active: boolean
  onClick: () => void
  label: string
  indicator?: boolean
}) {
  return (
    <button
      onClick={onClick}
      className="flex-1 px-3 py-2 text-xs font-medium transition-colors relative"
      style={{
        color: active ? 'var(--text-primary)' : 'var(--text-muted)',
        background: active ? 'transparent' : 'transparent',
        borderBottom: active ? '2px solid #F59E0B' : '2px solid transparent',
        cursor: 'pointer',
        border: 'none',
        outline: 'none',
      }}
    >
      {label}
      {indicator && (
        <span
          className="inline-block ml-1 w-1.5 h-1.5 rounded-full"
          style={{ background: '#10B981', verticalAlign: 'middle' }}
        />
      )}
    </button>
  )
}
